<section class="splide splide_2" aria-label="interior design">
  <div class="splide__track">
    <ul class="splide__list">

      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_1.jpg" class="img-fluid ">
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_2.jpg" class="img-fluid ">
          </div>
        </div>
      </li>

      <li id="test" class="splide__slide" #test>
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_5.jpg" class="img-fluid ">
          </div>
        </div>
      </li>
      
      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_2.jpg" class="img-fluid ">
          </div>
        </div>
      </li>


      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_3.jpg" class="img-fluid ">
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_4.jpg" class="img-fluid ">
          </div>
        </div>
      </li>
      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_5.jpg" class="img-fluid ">
          </div>
        </div>
      </li>
      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_6.jpg" class="img-fluid ">
          </div>
        </div>
      </li>
      <li class="splide__slide">
        <div class=" d-flex flex-column justify-content-center gap-3 ">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO22_7.jpg" class="img-fluid ">
          </div>
        </div>
      </li>

     

    </ul>
  </div>
</section>